import React from 'react';
import { CLICK, component, demoFile, story } from 'system/demo';
import { Pad } from 'component/basics';
import { UtilityText } from 'component/text';
import {
    TopicHeaderBox,
    TopHeaderBar,
    TopicLiveStatus,
    AskMeAnythingLiveStatus,
    MockTopicFollowButton,
    TopicParticipants,
} from 'open-modules/cbcrc/component/header';

demoFile('open-modules/cbcrc/component/header');

component('TopicHeaderBox', TopicHeaderBox, {
    args: {
        status: <UtilityText label="Status" color="" />,
        preHeading: undefined,
        title: 'Sample Title',
        content: <UtilityText text="Body content" />,
    },
});

component('TopHeaderBar', TopHeaderBar, {
    args: {
        tag: <TopicLiveStatus live={true} />,
        notificationSubscribed: false,
        notificationOnPress: () => {},
    },
});

component('AskMeAnythingLiveStatus', AskMeAnythingLiveStatus, {
    args: { live: true },
});

component('TopicLiveStatus', TopicLiveStatus, {
    args: { live: true },
});

component('MockTopicFollowButton', MockTopicFollowButton, {
    args: { notificationSubscribed: false, onPress: () => {} },
}, [
    story('Press', [CLICK('Follow')])
]);

component('TopicParticipants', TopicParticipants, {
    args: {
        count: 5,
        startAt: new Date('2024-01-01').toISOString(),
        endAt: new Date('2099-12-31').toISOString(),
    },
});

function TopicParticipantsEndedDemo() {
    return (
        <TopicParticipants
            count={2}
            startAt={new Date('2024-01-01').toISOString()}
            endAt={new Date('2024-01-02').toISOString()}
        />
    );
}

component('TopicParticipantsEnded', TopicParticipantsEndedDemo);
